import React from 'react'
import {
  Text,
  Box,
  Flex,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
  Button,
  CloseButton,
  Link,
} from '@chakra-ui/react'
import {Trans, useTranslation} from 'react-i18next'
import {useRails} from '../../../../contexts/rails'
import {Alert} from '../../../../components'
import {ShieldTickedIcon} from '../../../../icons'

const BankAccountDisconnected = () => {
  const {organisation} = useRails()
  const {t} = useTranslation()
  const {showBankAccountDisconnectionAlert} = organisation.currentSupplier
  const {isOpen, onClose} = useDisclosure({defaultIsOpen: true})
  const redirectToSettingsPage = () => {
    window.location.href = '/settings/banking'
  }

  if (!showBankAccountDisconnectionAlert) {
    return null
  }

  return (
    <>
      <Alert
        data-testid="bank-account-disconnected-banner"
        className="fs-unmask"
        status="error"
        message={
          <Box>
            <Flex justifyContent="space-between">
              <Box>
                <Text textStyle="body-intro">
                  {t('cashinPage:bankAccountDisconnectedBanner.title')}
                </Text>

                <Text mb="xs" textStyle="body-small">
                  {t('cashinPage:bankAccountDisconnectedBanner.body')}
                </Text>
              </Box>
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <Button
                variant="secondary"
                backgroundColor="transparent"
                my="auto"
                onClick={() => {
                  window.location.href = '/settings/banking'
                }}
              >
                {t('cashinPage:bankAccountDisconnectedBanner.link')}
              </Button>
            </Flex>
          </Box>
        }
      />

      <Modal size="2xl" isOpen={isOpen} onClose={onClose} preserveScrollBarGap>
        <ModalOverlay zIndex="1200" />
        <ModalContent
          className="fs-unmask"
          borderRadius="lg"
          zIndex="1200"
          containerProps={{zIndex: '1200'}}
        >
          <ModalHeader fontSize="base" p="0">
            <CloseButton
              position="absolute"
              top="0"
              right="0"
              mt="xs"
              mx="sm"
              onClick={onClose}
            />
          </ModalHeader>
          <ModalBody
            px="md"
            py="md"
            data-testid="bank-account-disconnected-modal"
          >
            <Text as="h3" textStyle="headline3" fontWeight="medium" pb="md">
              {t('cashinPage:bankAccountDisconnectedModal.title')}
            </Text>
            <Text textStyle="body-copy">
              {t('cashinPage:bankAccountDisconnectedModal.body')}
            </Text>
            <Flex backgroundColor="mld.neutral.100" px="sm" py="xs" my="sm">
              <ShieldTickedIcon mr="sm" mt="xxs" boxSize="5" />
              <Text textStyle="body-small">
                <Trans
                  t={t}
                  i18nKey="cashinPage:bankAccountDisconnectedModal.body2"
                  components={{
                    supportLink: (
                      <Link
                        variant="primary"
                        href="mailto:support@withmarmalade.com"
                      />
                    ),
                  }}
                />
              </Text>
            </Flex>
            <Flex my="md">
              <Button
                variant="primary"
                colorScheme="primary"
                mr="xs"
                onClick={redirectToSettingsPage}
              >
                {t('cashinPage:bankAccountDisconnectedModal.settingsLink')}
              </Button>
              <Button variant="tertiary" onClick={onClose} ml="xs">
                {t('cashinPage:bankAccountDisconnectedModal.closeLink')}
              </Button>
            </Flex>
            <Text textStyle="body-detail" color="neutral.700">
              <Trans
                t={t}
                i18nKey="cashinPage:bankAccountDisconnectedModal.footer"
                components={{
                  settingsLink: (
                    <Link textDecoration="underline" href="/settings/banking" />
                  ),
                }}
              />
            </Text>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  )
}

BankAccountDisconnected.propTypes = {}

export default BankAccountDisconnected
